import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_DELETE,
    MASTER_DATA_REMARK_INSERT,
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class TicketFeedback extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, ticketFeedbackDataSelectedEdit: data, ticketFeedback: data.description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, ticketFeedbackDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listTicketFeedback: [],
            ticketFeedback: '',
            ticketFeedbackDataSelectedEdit: {},
            ticketFeedbackDataSelectedDelete: {},
            showWarningTicketFeedback: false,
            showPopupInfo: false,
            showAddModal: false,
            showEditModal: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateTicketFeedback();
                this.getListTicketFeedback(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateTicketFeedback();
                this.getListTicketFeedback(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateTicketFeedback = () => {
        API_REMARK.getInitiateTicketFeedback(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListTicketFeedback = (current, pageSize) => {
        API_REMARK.getListTicketFeedback(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listTicketFeedback: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningTicketFeedback: false,
            ticketFeedback: ''
        });
    }

    handleConfirmAddTicketFeedback = () => {
        if (!this.state.ticketFeedback) return this.setState({ showWarningTicketFeedback: true });
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddTicketFeedback = () => {
        const data = {
            description: this.state.ticketFeedback,
            category: 'feedback-ticket'
        }

        API_REMARK.postDataRemark(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        ticketFeedback: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddTicketFeedback = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateTicketFeedback();
            this.getListTicketFeedback(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditTicketFeedback = () => {
        if (!this.state.ticketFeedback) return this.setState({ showWarningTicketFeedback: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditTicketFeedback = () => {
        const ticketFeedbackId = this.state.ticketFeedbackDataSelectedEdit.id;
        const data = {
            remark: this.state.ticketFeedbackDataSelectedEdit.remark,
            description: this.state.ticketFeedback,
            category: 'feedback-ticket',
            category_id: this.state.ticketFeedbackDataSelectedEdit.category_id,
            updated_at: this.state.ticketFeedbackDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(ticketFeedbackId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        ticketFeedback: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditTicketFeedback = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateTicketFeedback();
            this.getListTicketFeedback(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteTicketFeedback = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const ticketFeedbackId = this.state.ticketFeedbackDataSelectedDelete.id;
        const data = {
            remark: this.state.ticketFeedbackDataSelectedDelete.remark,
            category: 'feedback-ticket',
            updated_at: this.state.ticketFeedbackDataSelectedDelete.updated_at
        }
        API_REMARK.deleteDataRemark(ticketFeedbackId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteTicketFeedback = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateTicketFeedback();
            this.getListTicketFeedback(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateTicketFeedback();
        this.getListTicketFeedback(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Tiket Feedback"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  Ticket Feedback Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-96 top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>Tiket Feedback digunakan untuk list penilaian pada saat NexCare Mobile melakukan penilaian pada tiket yang sudah dikerjakan oleh CSO.</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add Ticket Feedback Button */}
                                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddticketfeedback" onClick={() => this.setState({ showAddModal: true })} className="flex items-center text-white py-2 px-6 rounded-md bg-nexcaredefault cursor-pointer">
                                            <IconAddTransparent />
                                            <span className="ml-2">Tiket Feedback</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                {/* Table Ticket Feedback */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listTicketFeedback}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Ticket Feedback Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Tiket Feedback</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlticketfeedbackadd"
                                        className="form-control resize-none"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="ticketFeedback"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningTicketFeedback: false });
                                        }}
                                        minLength="3"
                                        maxLength="100"
                                        autoComplete="off"
                                        value={this.state.ticketFeedback}
                                    />
                                    {this.state.showWarningTicketFeedback && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddticketfeedback" onClick={this.handleConfirmAddTicketFeedback}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Ticket Feedback Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Tiket Feedback</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlticketfeedbackedit"
                                        className="form-control resize-none"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="ticketFeedback"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningTicketFeedback: false });
                                        }}
                                        minLength="3"
                                        maxLength="100"
                                        autoComplete="off"
                                        value={this.state.ticketFeedback}
                                    />
                                    {this.state.showWarningTicketFeedback && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditticketfeedback" onClick={this.handleConfirmEditTicketFeedback}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Tiket Feedback" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddTicketFeedback} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddTicketFeedback} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Tiket Feedback" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditTicketFeedback} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditTicketFeedback} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Tiket Feedback" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, ticketFeedbackDataSelectedDelete: {} })} submit={this.handleDeleteTicketFeedback} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteTicketFeedback} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketFeedback);